import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Leaf, RefreshCcw, Snowflake } from 'lucide-react';
export function WhyFailed() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-6 bg-cream relative overflow-hidden" data-id="element-188">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0 opacity-10" data-id="element-189">
        <img src="https://cdn.magicpatterns.com/uploads/biZtp34xBR7hhHzLN8EZkJ/concepto_7.png" alt="Vegetales frescos" className="w-full h-full object-cover" data-id="element-190" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-191">
        <div className="text-center mb-16" data-id="element-192">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif text-forest font-bold mb-4" data-id="element-193">
            Por qué fallaron tus intentos anteriores
          </motion.h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-194"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-3 gap-8" data-id="element-195">
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-terracotta" data-id="element-196">
            <div className="w-14 h-14 bg-sage rounded-full flex items-center justify-center mb-6" data-id="element-197">
              <Leaf className="w-7 h-7 text-forest" data-id="element-198" />
            </div>
            <h3 className="text-xl font-bold text-forest mb-4 font-serif" data-id="element-199">
              Recetas con ingredientes "raros"
            </h3>
            <p className="text-brown" data-id="element-200">
              Te cansaste de las dietas que piden kale o aceite de coco que no
              bajás a comprar al chino. Necesitás comida real, con ingredientes
              de acá.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-terracotta" data-id="element-201">
            <div className="w-14 h-14 bg-sage rounded-full flex items-center justify-center mb-6" data-id="element-202">
              <RefreshCcw className="w-7 h-7 text-forest" data-id="element-203" />
            </div>
            <h3 className="text-xl font-bold text-forest mb-4 font-serif" data-id="element-204">
              Falta de sistema
            </h3>
            <p className="text-brown" data-id="element-205">
              Cocinabas para el momento y terminabas fregando ollas todas las
              noches. Eso no es sostenible cuando tenés una vida ocupada.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-terracotta" data-id="element-206">
            <div className="w-14 h-14 bg-sage rounded-full flex items-center justify-center mb-6" data-id="element-207">
              <Snowflake className="w-7 h-7 text-forest" data-id="element-208" />
            </div>
            <h3 className="text-xl font-bold text-forest mb-4 font-serif" data-id="element-209">
              El mito del "congelado feo"
            </h3>
            <p className="text-brown" data-id="element-210">
              Nadie te enseñó la técnica para que la comida sepa a recién hecha
              después de 15 días de freezer. Terminabas comiendo suelas de
              zapato.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}